(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name ImagenesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('ImagenesController', ImagenesController);

    ImagenesController.$inject = ["ImagenesService","$timeout","$location",'$anchorScroll','$uibModal'];

    function ImagenesController(ImagenesService,$timeout,$location,$anchorScroll,$uibModal)
    {
    	var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.categoria_id = {};
        vm.buscador = "";
        vm.imagenes = [];
        vm.items = 0;
		    vm.modalImg = "";
        vm.loading = false;

        vm.getImagenes = function(callback){
            vm.loading = true;
            ImagenesService.getImagenes(vm,function(data){
                vm.loading = false;
                vm.imagenes = data.imagenes;
                vm.maxPages = data.maxPages;
                vm.items = data.items;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-news').offset().top }, 1000);
                }
                if(typeof(callback) != 'undefined'){
                    callback();
                }

                //console.log(vm.maxPages );
            },function(){vm.loading = false;});
        };

 		
        vm.mostrarPop = function(img,index){
        	vm.modalImg = $uibModal.open({
	          animation: true,
	          ariaLabelledBy: 'modal-title-top',
	          ariaDescribedBy: 'modal-body-top',
	          templateUrl: 'popimg.html',
	          size: 'xl',
	          //backdrop:'static',
	          controller: function($scope) {
                  $scope.img = img;
                  $scope.index = index;
                  $scope.pag = vm.pag;
                  $scope.imagenes = vm.imagenes;
                  $scope.maxImagenes = vm.imagenes;
	                $scope.items = vm.items;

                  $scope.swiper = function(){
                    setTimeout(function(){
                      if ($('.swiper-orl-imgs').length != 0){
                        var sImgOrl = new Swiper(".swiper-orl-imgs", {
                            slidesPerView: 'auto',
                            spaceBetween:20,
                            autoHeight:true,
                            loop:false,
                            keyboard: {
                                enabled: true
                            },                    
                            preloadImages: false,
                            lazy: {
                               loadPrevNext: true,
                               loadPrevNextAmount: 1,
                               elementClass:'swiper-lazy'
                            },
                            a11y:{
                                enabled:true,
                                prevSlideMessage: 'Mostrar curso anterior',
                                nextSlideMessage:'Mostrar curso siguiente',
                                firstSlideMessage: 'Primer curso',
                                lastSlideMessage: 'Último curso',
                                paginationBulletMessage: 'Mostrar curso {{index}}'                        
                            },
                            navigation: {
                                nextEl: '.orlimg-next',
                                prevEl: '.orlimg-prev',
                            },
                            init:false,
                        });
                        sImgOrl.on('init', function() {
                          jQuery('.swiper-orl-imgs').addClass('ready');
                        }).init();
                      }
                    }, 300);
                  };
                  $scope.siguiente = function(){
                      if(vm.items-1 >= $scope.index+1){
                          if(typeof(vm.imagenes[$scope.index+1]) == 'undefined'){
                              vm.next(function(){
                                  $scope.img = vm.imagenes[0];
                                  $scope.pag = vm.pag;
                                  $scope.index = 0;
                                  console.log($scope);
                              });
                          }else{
                              $scope.img = vm.imagenes[$scope.index+1];
                              $scope.index++;
                          }
                          $scope.swiper();
                      }
                  };

                  $scope.anterior = function(){
                      if($scope.index-1 >= 0 || vm.pag > 0){
                          if(typeof(vm.imagenes[$scope.index - 1]) == 'undefined'){
                              vm.prev(function(){
                                  $scope.img = vm.imagenes[11];
                                  $scope.pag = vm.pag;
                                  $scope.index = 11;
                              });
                          }else{
                              $scope.img = vm.imagenes[$scope.index - 1];
                              $scope.index--;
                          }
                          $scope.swiper();
                      }
                  };
	             
	            $scope.okForm = function(){
	                vm.modalImg.close();
	            };
	           
	          }
	      	});

        };

        vm.next = function(callback){
        	vm.pag++;
        	vm.getImagenes(callback);
        };

        vm.prev = function(callback){
        	vm.pag--;
        	vm.getImagenes(callback);
        };


    }


})();